import React from 'react';
import { Link } from 'react-router-dom';
import {
  buildCampaignPath,
  buildLineItemPath,
  canRenderCampaignLink,
  canRenderLineItemLink
} from './card-links-utils';

const MUTED_LINK_CLASS =
  'text-muted-foreground block text-sm hover:text-foreground hover:underline';
const EMPHASIS_LINK_CLASS = 'block text-sm font-semibold hover:underline';

type CampaignLinkProps = {
  campaignId: string | null | undefined;
  campaignName: string | null | undefined;
  emphasis?: 'muted' | 'title';
};

export function CampaignLink({ campaignId, campaignName, emphasis = 'muted' }: CampaignLinkProps) {
  if (!canRenderCampaignLink(campaignId, campaignName)) return null;
  const className = emphasis === 'title' ? EMPHASIS_LINK_CLASS : MUTED_LINK_CLASS;
  return (
    <Link to={buildCampaignPath(campaignId as string)} className={className}>
      {campaignName}
    </Link>
  );
}

type LineItemLinkProps = {
  campaignId: string | null | undefined;
  lineItemId: string | null | undefined;
  lineItemName: string | null | undefined;
  sourcePhase: string | null | undefined;
};

export function LineItemLink({
  campaignId,
  lineItemId,
  lineItemName,
  sourcePhase
}: LineItemLinkProps) {
  if (!canRenderLineItemLink(campaignId, lineItemId, lineItemName)) return null;
  return (
    <Link
      to={buildLineItemPath(campaignId as string, lineItemId as string, sourcePhase)}
      className={EMPHASIS_LINK_CLASS}>
      {lineItemName}
    </Link>
  );
}
